import axios from '../../../utils/request';

function GET_MENULIST() {
    return axios.get("/admin/AAdminMenu/index" )
}
function ADD_DATA(params) {
    return  axios.get("/admin/AAdminMenu/add" )
}
function SUBMIT_ADD(params) {
    return  axios.post("/admin/AAdminMenu/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/admin/AAdminMenu/edit",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/admin/AAdminMenu/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/admin/AAdminMenu/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/admin/AAdminMenu/delete",{
        params: {
            ids:params
        }
    } )
}
function LIST_ORDER(params) {
    return  axios.post("/admin/AAdminMenu/listOrder",{ list_orders:params} )
}

export default {
    GET_MENULIST,
    ADD_DATA,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    LIST_ORDER
};